import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { t } from 'translation'
import LoadingButton from 'components/ui/LoadingButton/LoadingButton'
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import { connect } from 'react-redux'

import AuthErrorBox from 'components/Auth/AuthErrorBox'

import { contactApi } from 'api'
import { authFail, resetAuthError } from 'store/actions'

const FORM_INPUTS = [
  {
    id: 'question1',
    name: 'question1',
    type: 'text',
    labelText: 'QUESTION_1',
    fieldClass: '',
  },
  {
    id: 'question2',
    name: 'question2',
    type: 'text',
    labelText: 'QUESTION_2',
    fieldClass: '',
  },
  {
    id: 'question3',
    name: 'question3',
    type: 'text',
    labelText: 'QUESTION_3',
    fieldClass: '',
  },
  {
    id: 'user_email_address',
    name: 'email',
    type: 'email',
    labelText: 'EMAIL',
    fieldClass: 'read_only',
  },
]

const signupSchema = Yup.object().shape({
  email: Yup.string().email('INVALID_EMAIL').required('EMAIL_IS_REQUIRED'),
  question1: Yup.string().required('QUESTION_IS_REQUIRED').oneOf(['zero', 'one']),
  question2: Yup.string().required('QUESTION_IS_REQUIRED').oneOf(['zero', 'one']),
  question3: Yup.string().required('QUESTION_IS_REQUIRED').oneOf(['zero', 'one']),
})

const RequestAccessStepOne = ({ authFail, authError, setAccessStep, resetAuthError }) => {
  const [success, setSuccess] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  return (
    <Formik
      initialValues={{
        email: '',
        question1: '',
        question2: '',
        question3: '',
      }}
      validationSchema={signupSchema}
      onSubmit={async ({ email, question1, question2, question3 }) => {
        resetAuthError()
        setIsLoading(true)

        try {
          const { result, error } = await contactApi.createRequestAccessTicket({
            email,
            question1: question1 === 'zero' ? false : true,
            question2: question2 === 'zero' ? false : true,
            question3: question3 === 'zero' ? false : true,
            type: 'request_access',
          })

          if (error) throw Error(error?.message)

          setSuccess(true)
          setIsLoading(false)

          return setAccessStep('two')
        } catch (error) {
          console.log(
            'Error requesting access for new account: ',
            error?.error_description || error?.message || error
          )
          setIsLoading(false)
          return authFail(error)
        }
      }}
    >
      {({
        errors,
        touched,
        setFieldValue,
        handleChange,
        submitForm,
        status,
        setStatus,
      }) => (
        <Form className="tab_content_wrap auth_block">
          <h1 className="section_title v4_mod color_mod center_mod offset_v4_mod">
            {t('requestAccess.INSCRIPTION')}
          </h1>
          <div className="auth_block_descr offset_mod center_lvl_mod">
            {t('requestAccess.DESCRIPTION_1')}
          </div>
          {!success && (authError || status === 'clicked') ? (
            <AuthErrorBox
              formFields={['email', 'question1', 'question2', 'question3']}
              formTouched={touched}
              formErrors={errors}
              apiResponseError={authError || ''}
              resetApiResponseError={resetAuthError}
            />
          ) : null}
          <div className="auth_block_in">
            <div className="auth_block_input_w_list offset_v1_mod">
              <ul className="auth_block_input_list">
                <li
                  className={`auth_block_input_list_item v2_mod`}
                  key={FORM_INPUTS[0].id}
                >
                  <dl className="form_cell form_cell_v1_mod">
                    <dt className="form_cell_title form_v5_mod">
                      <label htmlFor={FORM_INPUTS[0].id}>
                        {t(`requestAccess.${FORM_INPUTS[0].labelText}`)}
                      </label>
                    </dt>
                    <dd className="form_field_wrap form_v5_mod">
                      <Field
                        className={`form_field v6_mod ${
                          status === 'clicked' && errors[FORM_INPUTS[0].name]
                            ? 'error'
                            : ''
                        } ${FORM_INPUTS[0].fieldClass}`}
                        type="radio"
                        name={FORM_INPUTS[0].name}
                        id={FORM_INPUTS[0].id}
                        value="one"
                        disabled={isLoading}
                      />
                      <label className="form_cell_title form_input_v1_mod">
                        {t(`requestAccess.TRUE`)}
                      </label>
                      <Field
                        className={`form_field v7_mod ${
                          status === 'clicked' && errors[FORM_INPUTS[0].name]
                            ? 'error'
                            : ''
                        } ${FORM_INPUTS[0].fieldClass}`}
                        type="radio"
                        name={FORM_INPUTS[0].name}
                        id={FORM_INPUTS[0].id}
                        value="zero"
                        disabled={isLoading}
                      />
                      <label className="form_cell_title form_input_v1_mod">
                        {t(`requestAccess.FALSE`)}
                      </label>
                    </dd>
                  </dl>
                </li>
                <li className={`auth_block_input_list_item`} key={FORM_INPUTS[1].id}>
                  <dl className="form_cell form_cell_v1_mod">
                    <dt className="form_cell_title form_v5_mod">
                      <label htmlFor={FORM_INPUTS[1].id}>
                        {t(`requestAccess.${FORM_INPUTS[1].labelText}`)}
                      </label>
                    </dt>
                    <dd className="form_field_wrap form_v5_mod">
                      <Field
                        className={`form_field v6_mod ${
                          status === 'clicked' && errors[FORM_INPUTS[1].name]
                            ? 'error'
                            : ''
                        } ${FORM_INPUTS[1].fieldClass}`}
                        type="radio"
                        name={FORM_INPUTS[1].name}
                        value="one"
                        id={FORM_INPUTS[1].id}
                        disabled={isLoading}
                      />
                      <label className="form_cell_title form_input_v1_mod">
                        {t(`requestAccess.TRUE`)}
                      </label>
                      <Field
                        className={`form_field v7_mod ${
                          status === 'clicked' && errors[FORM_INPUTS[1].name]
                            ? 'error'
                            : ''
                        } ${FORM_INPUTS[1].fieldClass}`}
                        type="radio"
                        name={FORM_INPUTS[1].name}
                        id={FORM_INPUTS[1].id}
                        value="zero"
                        disabled={isLoading}
                      />
                      <label className="form_cell_title form_input_v1_mod">
                        {t(`requestAccess.FALSE`)}
                      </label>
                    </dd>
                  </dl>
                </li>
                <li
                  className={`auth_block_input_list_item v1_mod`}
                  key={FORM_INPUTS[2].id}
                >
                  <dl className="form_cell form_cell_v1_mod">
                    <dt className="form_cell_title form_v5_mod">
                      <label htmlFor={FORM_INPUTS[2].id}>
                        {t(`requestAccess.${FORM_INPUTS[2].labelText}`)}
                      </label>
                    </dt>
                    <dd className="form_field_wrap form_v5_mod">
                      <Field
                        className={`form_field v6_mod ${
                          status === 'clicked' && errors[FORM_INPUTS[2].name]
                            ? 'error'
                            : ''
                        } ${FORM_INPUTS[2].fieldClass}`}
                        type="radio"
                        name={FORM_INPUTS[2].name}
                        id={FORM_INPUTS[2].id}
                        value="one"
                        disabled={isLoading}
                      />
                      <label className="form_cell_title form_input_v1_mod">
                        {t(`requestAccess.TRUE`)}
                      </label>
                      <Field
                        className={`form_field v7_mod ${
                          status === 'clicked' && errors[FORM_INPUTS[2].name]
                            ? 'error'
                            : ''
                        } ${FORM_INPUTS[2].fieldClass}`}
                        type="radio"
                        name={FORM_INPUTS[2].name}
                        id={FORM_INPUTS[2].id}
                        value="zero"
                        disabled={isLoading}
                      />
                      <label className="form_cell_title form_input_v1_mod">
                        {t(`requestAccess.FALSE`)}
                      </label>
                    </dd>
                  </dl>
                </li>
                <li className={`auth_block_input_list_item`} key={FORM_INPUTS[3].id}>
                  <dl className="form_cell form_cell_v1_mod">
                    <dd className="form_field_wrap form_v3_mod">
                      <Field
                        className={`form_field v4_mod ${
                          status === 'clicked' && errors[name] ? 'error' : ''
                        } ${FORM_INPUTS[3].fieldClass}`}
                        type={FORM_INPUTS[3].type}
                        placeholder={t(`requestAccess.${FORM_INPUTS[3].labelText}`)}
                        name={FORM_INPUTS[3].name}
                        id={FORM_INPUTS[3].id}
                        disabled={isLoading}
                      />
                    </dd>
                  </dl>
                </li>
              </ul>
            </div>
            <div className="btn_wrap center_lvl_mod">
              <LoadingButton
                className="btn_base_v1 offset_mod"
                isLoading={isLoading}
                disabled={success}
                onClick={(e) => {
                  e.preventDefault()

                  setStatus('clicked')
                  submitForm()
                }}
              >
                {t('signup.CONTINUE')}
              </LoadingButton>
              <span className="auth_block_member_link">
                {t('signup.ALREADY_MEMBER')}
                <Link to="/login">{t('signup.CONNECT')}</Link>
              </span>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  )
}

const mapStateToProps = ({ auth: { error, attributes } }) => ({
  alwaysOnWelcomeVideo: attributes?.permissions?.features?.alwaysOnWelcomeVideo,
  authError: error,
})

const willMapDispatchToProps = {
  authFail,
  resetAuthError,
}

export default connect(mapStateToProps, willMapDispatchToProps)(RequestAccessStepOne)
